@if (!langState.lang) {
  <tvh-language-select (langSelected)="setAppLanguage($event)"></tvh-language-select>
}

<!--Amplify Auth-->
@if (langState.lang) {
  <amplify-authenticator hideSignUp>
    <ng-template amplifySlot="sign-in">
      <div class="sign-in-container">
        <div class="sign-in">
          <img class="logo" src="assets/images/qreddi_logo_pos_rgb.svg" />
          @if (auth.isInProgress) {
            <mat-progress-bar class="loading-bar" mode="indeterminate"></mat-progress-bar>
          }
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{ 'SIGN_IN.SIGN_IN' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="social-login-buttons">
                <cool-facebook-button color="dark" (click)="auth.signInFacebook()" [disabled]="auth.isInProgress">
                  {{ 'SIGN_IN.WITH_FACEBOOK' | translate }}
                </cool-facebook-button>
                <cool-google-button color="dark" (click)="auth.signInGoogle()" [disabled]="auth.isInProgress">
                  {{ 'SIGN_IN.WITH_GOOGLE' | translate }}
                </cool-google-button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </ng-template>
    <ng-template amplifySlot="authenticated">
      <div class="toolbar" role="banner">
        <mat-toolbar>
          <button mat-icon-button class="home" aria-label="Home" (click)="toHome()">
            <mat-icon>home</mat-icon>
          </button>
          <div class="page-title">{{ titleState.title }}</div>
          <div class="spacer"></div>
          <button mat-icon-button [matMenuTriggerFor]="menu" class="menu" aria-label="Menu">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (auth.isManager) {
              <button mat-menu-item (click)="toSettings()">
                <mat-icon>settings</mat-icon>
                <span>{{ 'ADMIN.TITLE' | translate }}</span>
              </button>
            }
            <button mat-menu-item (click)="toProfile()">
              <mat-icon>account_circle</mat-icon>
              <span>{{ 'MENU.PROFILE' | translate }}</span>
            </button>
            <button mat-menu-item (click)="toTransactionHistory()">
              <mat-icon>history</mat-icon>
              <span>{{ 'MENU.TRANSACTIONS' | translate }}</span>
            </button>
            <button mat-menu-item (click)="toAddCredit()">
              <mat-icon>credit_card_outline</mat-icon>
              <span>{{ 'MENU.ADD_CREDIT' | translate }}</span>
            </button>
            <button mat-menu-item (click)="toLocation()">
              <mat-icon>place</mat-icon>
              <span>{{ 'MENU.CHANGE_LOCATION' | translate }}</span>
            </button>
            <button mat-menu-item (click)="changeLanguage()">
              <mat-icon>translate</mat-icon>
              <span>{{ 'MENU.LANGUAGE' | translate }}</span>
            </button>
            <button mat-menu-item (click)="toContactForm()">
              <mat-icon>help_center</mat-icon>
              <span>{{ 'MENU.CONTACT' | translate }}</span>
            </button>
            <button mat-menu-item (click)="auth.signOut()">
              <mat-icon>logout</mat-icon>
              <span>{{ 'MENU.SIGN_OUT' | translate }}</span>
            </button>
            <div class="menu-version" aria-label="Application version">
              <span>API: {{ apiVersion() }}</span>
              <span>UI: {{ appVersion }}</span>
            </div>
          </mat-menu>
        </mat-toolbar>
      </div>
      <div class="balance-bar" role="complementary">
        <mat-toolbar class="accent-toolbar">
          @if (locationState.locationName) {
            <span>{{ locationState.locationName }}</span>
          }
          <div class="spacer"></div>
          @if (profile.balance >= 0) {
            <span>{{ 'MENU.BALANCE' | translate }}: {{ profile.balance | euro }}</span>
          }
        </mat-toolbar>
      </div>
      @if (loading.showBar) {
        <mat-progress-bar class="loading-bar" mode="indeterminate"></mat-progress-bar>
      }
      <div class="application-content">
        @if (loading.showSpinner) {
          <div class="loading-spinner">
            <mat-spinner class="accent-spinner"></mat-spinner>
          </div>
        }
        <router-outlet></router-outlet>
      </div>
    </ng-template>
  </amplify-authenticator>
}
